// src/modules/app-views/toolbox/pages/Ai/components/ToolboxAiHeader.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Flex, theme } from 'antd';
import translateX from 'utils/translateX';
import aiGenerativeIcon from 'assets/images/ai-generative.png';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
/**
 * ToolboxAiHeader - Reusable header component for AI tool cataloging screens
 */
const ToolboxAiHeader = ({
  isMobile,
  children,
}) => {
  // ---------------------------------------------------------------------------
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ---------------------------------------------------------------------------
  const { token } = theme.useToken();

  // ---------------------------------------------------------------------------
  // 2. HOOKS & REFS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 3. LOCAL VARIABLES I
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 4. LOCAL STATE
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 5. EFFECTS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 6. HANDLERS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 7. LOCAL VARIABLES II
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 8. UI
  // ---------------------------------------------------------------------------
  return (
    <Flex
      vertical
      align="center"
      justify="center"
      style={isMobile ? { padding: '40px 0' } : { height: '100%' }}
    >
      <div
        style={{
          width: isMobile ? 64 : 80,
          height: isMobile ? 64 : 80,
          marginBottom: 24,
          backgroundColor: token.colorPrimary,
          WebkitMaskImage: `url(${aiGenerativeIcon})`,
          WebkitMaskSize: 'contain',
          WebkitMaskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center',
          maskImage: `url(${aiGenerativeIcon})`,
          maskSize: 'contain',
          maskRepeat: 'no-repeat',
          maskPosition: 'center',
        }}
      />
      <div
        className="text-center"
        style={{
          fontSize: isMobile ? 18 : 28,
          fontWeight: 500,
          marginBottom: 24,
        }}
      >
        {translateX('ai_tool_cataloging')}
      </div>

      {/* Additional content passed as children */}
      {children}
    </Flex>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ToolboxAiHeader;
